import React, { Fragment } from 'react';
import { string, bool, array, shape, object } from 'prop-types';

import { Tab } from 'semantic-ui-react';

import Section from '~/views/common/Section';
import DataTable from '~/views/common/DataTable';
import BoolIcon from '~/views/common/BoolIcon';

import SSO from '~/views/common/SSO';
import Author from '~/views/common/Author';
import UsersStats from '~/views/common/UsersStats';
import Licenses from '~/views/common/Licenses';
import Address from '~/views/common/Address';
import Contact from '~/views/common/Contact';


const TabGeneral = ({
    data: {
        id,
        name,
        slug,
        product,
        author_id,
        // sometimes we don't get 'portal' back on the response
        portal: isPortal = false,
        private: isPrivate,
        closed,
        deleted,
        archived,
        allow_offline,
        allow_private_groups,
        allow_shoutbox,
        show_impact_meter,
        general_opportunity_enabled,
        offline_opps_require_contact,
        disable_email_notifications,
        bypass_content_moderation,
        student_graduation_required,
        licenses,
        vanity,
        description,
        organization_type,
        created,
        modified,
        contact,
        address,
        url,
        duns,
        phone,
    },
}) => (
    <Tab.Pane>
        <Section name="Info">
            <DataTable.Body>
                <DataTable.Row header="ID">{ id }</DataTable.Row>

                <DataTable.Row header="Name">{ name }</DataTable.Row>

                <DataTable.Row header="Product">{ product }</DataTable.Row>

                <DataTable.Row header="Type">{ organization_type }</DataTable.Row>

                <DataTable.Row header="Slug">{ slug }</DataTable.Row>

                <DataTable.Row header="Vanity">{ vanity }</DataTable.Row>

                <DataTable.Row header="DUNS">{ duns }</DataTable.Row>

                <DataTable.Row header="Description">{ description }</DataTable.Row>

                <DataTable.Row header="Phone">{ phone }</DataTable.Row>

                <DataTable.Row header="Website">{ url }</DataTable.Row>

                <DataTable.Row header="Created">{ created }</DataTable.Row>

                <DataTable.Row header="Modified">{ modified }</DataTable.Row>

                { /* Settings */ }
                <DataTable.Row header="Portal"><BoolIcon value={isPortal} /></DataTable.Row>

                <DataTable.Row header="Private"><BoolIcon value={isPrivate} /></DataTable.Row>

                <DataTable.Row header="Closed"><BoolIcon value={closed} /></DataTable.Row>

                <DataTable.Row header="Deleted"><BoolIcon value={deleted} /></DataTable.Row>

                <DataTable.Row header="Archived"><BoolIcon value={archived} /></DataTable.Row>

                <DataTable.Row header="Show Impact Meter"><BoolIcon value={show_impact_meter} /></DataTable.Row>

                <DataTable.Row header="Allow Offline"><BoolIcon value={allow_offline} /></DataTable.Row>

                <DataTable.Row header="Allow Private Groups"><BoolIcon value={allow_private_groups} /></DataTable.Row>

                <DataTable.Row header="Allow Shoutbox"><BoolIcon value={allow_shoutbox} /></DataTable.Row>

                <DataTable.Row header="Disable Email Notifications"><BoolIcon value={disable_email_notifications} /></DataTable.Row>

                <DataTable.Row header="Offline Opps Require Contact"><BoolIcon value={offline_opps_require_contact} /></DataTable.Row>

                <DataTable.Row header="General Opportunity Enabled"><BoolIcon value={general_opportunity_enabled} /></DataTable.Row>

                <DataTable.Row header="Bypass Content Moderation"><BoolIcon value={bypass_content_moderation} /></DataTable.Row>

                <DataTable.Row header="Student Graduation Required"><BoolIcon value={student_graduation_required} /></DataTable.Row>
            </DataTable.Body>
        </Section>

        <Author id={author_id} />

        { isPortal &&
            <Fragment>
                <Licenses licenses={licenses} />
                <SSO id={id} />
            </Fragment>
        }

        <UsersStats id={id} />

        <Contact contact={contact} />

        <Address address={address} />
    </Tab.Pane>
);

TabGeneral.propTypes = {
    data: shape({
        id: string.isRequired,
        name: string.isRequired,
        author_id: string.isRequired,
        product: string.isRequired,
        slug: string,
        portal: bool,
        private: bool,
        closed: bool,
        deleted: bool,
        archived: bool,
        allow_offline: bool,
        allow_private_groups: bool,
        allow_shoutbox: bool,
        show_impact_meter: bool,
        general_opportunity_enabled: bool,
        offline_opps_require_contact: bool,
        disable_email_notifications: bool,
        bypass_content_moderation: bool,
        student_graduation_required: bool,
        licenses: array,
        vanity: string,
        description: string,
        organization_type: string,
        created: string,
        modified: string,
        contact: object,
        address: object,
    }).isRequired,
};

export default TabGeneral;
